<template>
  <div v-if="visivel" class="modal is-active">

    <div class="modal-background" @click="fechar"></div>

    <div class="modal-card">
      <header class="modal-card-head has-background-primary">
        <p class="modal-card-title">
          Fórmulas do Perfil — {{ linha?.descricao.substring(0,25) || 'Linha não selecionada' }}
        </p>
        <button class="delete" aria-label="close" @click="fechar"></button>
      </header>

      <section class="modal-card-body">
        <!-- Tabela de fórmulas -->
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>Perfil</th>
              <th>Fórmula</th>
              <th class="has-text-centered">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(formula, index) in formulas" :key="formula.id">
              <td>{{ formula.perfil.descricao }}</td>
              <td>{{ formula.formula }}</td>
              <td class="has-text-centered">
                <button class="button is-small is-info is-outlined" @click="editarFormula(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-edit"></i>
                  </span>
                </button>
                <button class="button is-small is-danger is-outlined" @click="excluirFormula(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-trash"></i>
                  </span>
                </button>
              </td>
            </tr>

            <tr v-if="formulas.length === 0">
              <td colspan="3" class="has-text-centered has-text-grey">
                Nenhuma fórmula cadastrada para esta linha.
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Botão nova fórmula -->
        <div class="has-text-right mt-3">
          <button class="button is-success" @click="novaFormula" :disabled="habilitaLancamento">
            Cadastrar
          </button>
        </div>

        <br/>

        <div class="card" v-if="habilitaLancamento">
          <header class="card-header">
            <p class="card-header-title">Edição</p>            
          </header>
        
          <div class="card-content">
            <form class="is-fullwidth">
              <!-- Campo Perfil -->
              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Perfil</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="indicadorFormulaPerfil.perfil" class="is-fullwidth" :disabled="indicadorFormulaPerfil.id != null">
                          <option v-for="up in usuariosPerfil" :key="up.perfil.id" :value="up.perfil.id">
                            {{ up.perfil.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Campo Fórmula -->
              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Fórmula</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <textarea
                        class="textarea is-fullwidth"
                        placeholder="Informe a fórmula do perfil"
                        v-model="indicadorFormulaPerfil.formula"
                        rows="3">
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <footer class="card-footer">
            <button class="button is-success" @click="save">Salvar</button>
            <button class="button" v-on:click="habilitaLancamento = false">Cancelar</button>
          </footer>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: "IndicadorFormulasPerfil",
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    linha: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      indicadorFormulaPerfil: {
          id: null,
          indicador: null,
          perfil: null,
          formula: null
      },
      formulas: [],
      usuariosPerfil: [],
      habilitaLancamento: false
    };
  },
  watch: {
    linha(novaLinha) {
      if (novaLinha && novaLinha.id) {
        this.carregarFormulas();
      }
    },
    visivel(novoValor) {
      if (novoValor && this.linha?.id) {
        this.carregarFormulas();
      }
    }
  },
  methods: {
    clearFields: function() {
      this.indicadorFormulaPerfil = {
        id: null,
        indicador: parseInt(this.linha.id),
        perfil: null,
        formula: null,
        index: null
      }
    },

    save: function() {
      var data

      if (this.indicadorFormulaPerfil.perfil == null) {
          alert('Perfil não selecionado!')
          return
      }

      if (this.indicadorFormulaPerfil.formula == null || this.indicadorFormulaPerfil.formula == '' ) {
          alert('Fórmula não informada!')
          return
      }

      data = {id: this.indicadorFormulaPerfil.id,
          indicador: this.indicadorFormulaPerfil.indicador,
          perfil: this.indicadorFormulaPerfil.perfil,
          formula: this.indicadorFormulaPerfil.formula          
      }

      if (this.indicadorFormulaPerfil.id == null) {
          http.post('/indicador/adicionarFormulaPerfil', data).then(response =>{
              if (response.data.id != undefined && response.data.id != '') {
                  this.indicadorFormulaPerfil.id = response.data.id

                  // 🔹 Reatribui o objeto completo do perfil antes de inserir
                  const perfilObj = this.usuariosPerfil.find(
                    up => up.perfil.id === this.indicadorFormulaPerfil.perfil
                  );

                  if (perfilObj) {
                    this.indicadorFormulaPerfil.perfil = perfilObj.perfil;
                  }

                  this.formulas.push(this.indicadorFormulaPerfil)
                  this.clearFields()
              } else {
                  alert(response.request.responseText)
              }
          }).catch(e => {
              alert(e.response.data);
              return
          })
      } 
      else {
          http.put('/indicador/editarFormulaPerfil/'+this.indicadorFormulaPerfil.id, data).then(response =>{
              this.formulas[this.indicadorFormulaPerfil.index].formula = response.data.formula
          }).catch(e => {
              alert(e.response.data);
              return
          })
      }                    

    },

    async carregarFormulas() {
      if (!this.linha || !this.linha.id) return;

      try {
        const response = await http.get(`/indicador/listarFormulaPerfil/`, {
          params: { idIndicador: parseInt(this.linha.id) }
        });
        this.formulas = response.data.results;
      } catch (error) {
        console.error("Erro ao carregar fórmulas:", error);
        alert("Não foi possível carregar as fórmulas. Verifique a linha selecionada ou tente novamente.");
      }
    },

    async novaFormula() {
      this.habilitaLancamento = true
      this.clearFields()
    },

    async editarFormula(index) {
      this.habilitaLancamento = true
      this.indicadorFormulaPerfil.id = this.formulas[index].id
      this.indicadorFormulaPerfil.indicador = parseInt(this.linha.id)
      this.indicadorFormulaPerfil.perfil = this.formulas[index].perfil.id
      this.indicadorFormulaPerfil.formula = this.formulas[index].formula
      this.indicadorFormulaPerfil.index = index
    },

    async excluirFormula(index) {
      if (window.confirm('Confirma exclusão?')) {
            http.delete('/indicador/excluirFormulaPerfil/'+this.formulas[index].id).then(response =>{
                this.formulas.splice(index, 1)
                if (response.status == 204) {
                    alert('Registro excluído!')
                }
            }).catch(e => {
                console.log(e);
            })
      }
    },

    fechar() {
      this.$emit("fechar");
    },
  },

  mounted() {
    http.get('compartilharPerfis/listarPerfis')
      .then(response => {
        this.usuariosPerfil = response.data.results;
      })
      .catch(error => {
        console.error("Erro ao carregar perfis:", error);
      });

      this.carregarFormulas()
  }
};
</script>